import { Badge, Box } from '@mui/material';
import styled, { keyframes } from 'styled-components';

type TBlinkingBadgeProps = {
  $size?: number;
  $top?: number;
  $right?: number;
  $blinkDuration?: string;
};

const pulseAnimation = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.25;
    transform: scale(0.8);
  }
`;

export const BlinkingIndicatorBadge = styled(Badge)<TBlinkingBadgeProps>`
  && {
    display: block;

    .MuiBadge-badge {
      top: ${({ $top = -2 }) => `${$top}px`};
      right: ${({ $right = -1 }) => `${$right}px`};
      min-width: ${({ $size = 10 }) => `${$size}px`};
      height: ${({ $size = 10 }) => `${$size}px`};
      border-radius: 50%;
      transform-origin: center;
      animation: ${pulseAnimation}
        ${({ $blinkDuration = '1.2s' }) => $blinkDuration} ease-in-out infinite;
    }
  }
`;

export const BlinkingIndicatorContent = styled(Box)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
`;
